import React, { useMemo } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';

function normalizeSlides(mainSrc, prevSrc, nextSrc, imageTitle) {
  const slides = [];
  const addSlide = (src) => {
    if (!src) return;
    if (slides.some((slide) => slide.src === src)) return;
    slides.push({ src, title: imageTitle });
  };

  addSlide(prevSrc);
  addSlide(mainSrc);
  addSlide(nextSrc);

  const index = Math.max(
    0,
    slides.findIndex((slide) => slide.src === mainSrc),
  );

  return { slides, index };
}

export default function LegacyLightbox({
  mainSrc,
  nextSrc,
  prevSrc,
  onCloseRequest,
  onMovePrevRequest,
  onMoveNextRequest,
  imageTitle,
}) {
  const { slides, index } = useMemo(
    () => normalizeSlides(mainSrc, prevSrc, nextSrc, imageTitle),
    [mainSrc, prevSrc, nextSrc, imageTitle],
  );

  return (
    <Lightbox
      open={Boolean(mainSrc)}
      close={onCloseRequest}
      slides={slides}
      index={index}
      plugins={[Zoom]}
      carousel={{
        imageFit: 'contain',
        padding: 32,
      }}
      styles={{
        root: {
          '--yarl__portal_zindex': 10005,
        },
        slide: {
          alignItems: 'center',
          justifyContent: 'center',
        },
        container: {
          backgroundColor: '#000',
        },
      }}
      on={{
        view: ({ index: nextIndex }) => {
          if (nextIndex < index && onMovePrevRequest) onMovePrevRequest();
          if (nextIndex > index && onMoveNextRequest) onMoveNextRequest();
        },
      }}
    />
  );
}
